"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RegisterController_js_1 = require("./RegisterController.js");
exports.RegisterController = RegisterController_js_1.RegisterController;



//////////////////
// WEBPACK FOOTER
// ./scripts/core/register/controllers/index.js
// module id = 324
// module chunks = 0